export enum TreeViewDragRelation {
    CHILD = 'CHILD',
    SIBLING = 'SIBLING',
}

export enum TreeViewDragStatus {
    DRAGGING = 'DRAGGING',
    STAND_BY = 'STAND_BY',
}
